export default __webpack_public_path__ + "static/media/navbar-detailed-orange.3d47da7c.svg";